<p-dialog header="Inscreva-se" [(visible)]="showModal" [style]="{width: '500px'}" (onHide)="closeModal()" modal="true">

  <p><strong>Curso: </strong> {{curso.titulo}}</p>

  <p class="title text-warning fw-4">Para se increver no curso deverá seguir os seguintes procedimentos:</p>


  <div class="step my-3">
    <p>1 - Efectuar a tranferência bancária</p>
    <p class="ps-3">IBAN: <strong>0044 0000 6841 2577 1017 2</strong> </p>
    <p class="ps-3">Nome: <strong>Nilton Staloni Henriques de Matos</strong> </p>
    <p class="ps-3">Valor: <strong>{{curso.preco | currency: '(AOA)'}}</strong> </p>
  </div>

  <div class="step my-3">
    <p>2 - Confirmar a inscrição</p>
  </div>

  <div class="step my-3">
    <p>
      3 - Após a tranferência efectuada navegar até <strong><a [routerLink]="['/conta']">
          Conta,</a></strong> selecionar a opção 'Subscrições' e submeter o comprovativo de
      pagamento para o curso selecionado
    </p>
  </div>

  <div class="actions row">
    <div class="col-md-4">
      <button class="btn btn-transparent w-100" (click)="closeModal()">
        Cancelar
      </button>
    </div>
    <div class="col-md-8">
      <button pButton type="button" label="Confirmar a inscrição" icon="la la-check"
        class="p-button p-button-primary w-100" (click)="inscrever()">
      </button>
    </div>
  </div>

</p-dialog>